export default 'skill-bite-list'
